// extracted by mini-css-extract-plugin
module.exports = {"blogReviewer":"az_Tp","reviewerText":"az_Up","withVerticalPadding":"az_Vp","withDate":"az_Wp"};